<template>
  <div class="banner">
    <van-swipe vertical height="100%" :loop="false" :show-indicators="false" @change="change">
      <van-swipe-item class="swiperItem1">
        <img src="../assets/imgs/banner1.png" class="single" alt="">
        <button class="btn" @click="downLoad">立即下载</button>
        <img src="../assets/imgs/a.png" alt="" class="arrow" />
        <div class="isMaskShow" v-show="isMaskShow" @click="isMaskShow = false">
          <img src="../assets/imgs/arrow.png" alt="" />
        </div>
      </van-swipe-item>

      <van-swipe-item class="swiperItem2">
        <img src="../assets/imgs/banner2.png" class="single" alt="">
        <img src="../assets/imgs/a.png" alt="" class="arrow" />
      </van-swipe-item>

      <van-swipe-item class="swiperItem3">
        <img src="../assets/imgs/banner3.png" class="single" alt="">

        <img src="../assets/imgs/a.png" alt="" class="arrow" />
      </van-swipe-item>

      <van-swipe-item class="swiperItem4 swiperDown">
        <div class="down">
          <img src="../assets/imgs/logo.png" alt="" srcset="" />
          <p>下载交运通APP</p>
          <span>- 您的出行好帮手 -</span>
          <button class="btn2" @click="downLoad">立即下载</button>
          <img src="../assets/imgs/opticy.png" class="opticy" />
          <img src="../assets/imgs/b.png" alt="" class="arrow" />
        </div>
        <div class="isMaskShow" v-show="isMaskShow" @click="isMaskShow = false">
          <img src="../assets/imgs/arrow.png" alt="" />
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { getVersion } from "@/api/banner.js";
import { Toast } from "vant";

export default {
  data() {
    return {
      isMaskShow: false,
      androidUrl: "",
    };
  },

  mounted() {
    var option = {
      head: {},
      body: {
        osType: "Android",
      },
    };
    getVersion(option).then((res) => {
      if (res.code == 200) {
        this.androidUrl = res.data.targeUrl;
      } else {
        Toast.fail("获取安卓下载地址失败!"+res.message);
      }
    });
  },

  methods: {
    change(index) {
      //   console.log(index);
      
    },

    downLoad() {
      //判断是否在微信中打开
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;

      var u = navigator.userAgent,
        isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1,
        isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
        urls = {
          android: this.androidUrl,
          ios: "https://itunes.apple.com/cn/app/交运通-移动出行/id1330134308?l=zh&ls=1&mt=8",
        };
      if (isWeixin) {
        if (isiOS) {
          window.location.href = urls.ios;
        }
        if (isAndroid) {
          this.isMaskShow = true;
        }
      } else if (isAndroid) {
        window.location.href = urls.android;
      } else if (isiOS) {
        window.location.href = urls.ios;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.single {
  position: absolute;
  width: 100%;
  height: 100%;
}

.banner {
  position: absolute;
  // background: #FD8A22;
  width: 100%;
  height: 100%;
  z-index: 888;

  ::v-deep .van-swipe {
    width: 100%;
    height: 100%;
  }

  .btn {
    color: #a46b03;
    width: 208px;
    height: 45px;
    background: #fad518;
    border-radius: 22px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 200;
    line-height: 45px;
    border: 1px solid #fad518;
    margin-bottom: 120px;
    position: absolute;
  }
  .btn2 {
    color: #a46b03;
    width: 208px;
    height: 45px;
    background: #fad518;
    border-radius: 22px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 200;
    line-height: 45px;
    border: 1px solid #fad518;
    margin-bottom: 120px;
  }
}

.swiperItem1 {
  // background: url("../assets/imgs/banner1.png");
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: linear-gradient(0deg, #ff8921, #fda455);
}

.swiperItem2 {
  // background: url("../assets/imgs/banner2.png");
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: linear-gradient(0deg, #ff8921, #fda455);
}

.swiperItem3 {
  // background: url("../assets/imgs/banner3.png");
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: linear-gradient(0deg, #ff8921, #fda455);
}

.swiperItem4 {
  width: 100%;
  height: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(0deg, #ff8921, #fda455);
}

.down {
  display: flex;
  flex-direction: column;
  align-items: center;

  >img:first-of-type {
    width: 120px;
    height: 120px;
  }

  p {
    font-size: 34px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 30px;
  }

  span {
    font-size: 20px;
    color: #ffffff;
    font-family: Microsoft YaHei;
    font-weight: bold;
    margin-bottom: 90px;
  }

  .opticy {
    width: 100%;
    position: fixed;
    bottom: 0;
    pointer-events: none;
  }
}

.arrow {
  position: absolute;
  width: 30px;
  bottom: 20px;
  z-index: 999;
  //   left: 50%;
}

.isMaskShow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #999;
  opacity: 0.5;

  img{
    position: absolute;
    z-index: 99;
    top: 20px;
    right: 20px;
    width: 250px;
    height: 100px;
  }
}
</style>